define('modules/start/products/index',['require','exports','module','./email/index','./sms/index','./landings/index','./trans/index','./automation/index','./view'],function (require, exports, module) {
  "use strict";

  module.exports = {
    Modules: {
      MDirector: [
        require("./email/index"),
        require("./sms/index")
      ],
      Landings: [
        require("./landings/index")
      ],
      Transaccionales: [
        require("./trans/index")
      ],
      Automation: [
        require("./automation/index")
      ]
    },
    View: require("./view")
  };
});

